export const HASH_TARGET_RESOLVE_EVENT = 'reactwp:resolve-hash-target';

export const getHashElement = (hash) => {
    if(typeof document === 'undefined' || !hash || hash === '#'){
        return null;
    }

    let id = hash.slice(1);

    try {
        id = decodeURIComponent(id);
    } catch(error){
        id = hash.slice(1);
    }

    const element = document.getElementById(id);

    if(element){
        return element;
    }

    try {
        return document.querySelector(hash);
    } catch(error){
        return null;
    }
};

const isScrollTarget = target => {
    if(typeof target === 'number'){
        return Number.isFinite(target);
    }

    return typeof target === 'string' && target !== '';
};

export const getResolvedHashTarget = (hash) => {
    if(typeof window !== 'undefined' && hash && hash !== '#'){
        const detail = {
            hash,
            target: null
        };

        window.dispatchEvent(new CustomEvent(HASH_TARGET_RESOLVE_EVENT, { detail }));

        if(isScrollTarget(detail.target)){
            return detail.target;
        }
    }

    return getHashElement(hash) ? hash : null;
};

export const resolveHashTarget = hash => getResolvedHashTarget(hash) ?? 0;
